// import Vue from 'vue'
// import VueChartist from 'vue-chartist'
// const Chartist = require('chartist') // ✅ méthode compatible CommonJS
// window.Chartist = Chartist
// require('chartist-plugin-tooltips-updated') // ✅ injecte Chartist.plugins.tooltip'

// import 'chartist/dist/index.css'
// import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.css'
// // import 'chartist-plugin-tooltips-updated'

// Vue.use(VueChartist)
// export default Chartist

import Vue from 'vue'
import Chartist from 'chartist'
import VueChartist from 'vue-chartist'
// import 'chartist/dist/index.css'
import 'chartist/dist/chartist.min.css'
import 'chartist-plugin-tooltips-updated'
import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.css'

Vue.use(VueChartist)
// Vue.use(require('vue-chartist'))


const ChartistTooltip = require('chartist-plugin-tooltips-updated')

export { Chartist, ChartistTooltip }
